export default __webpack_public_path__ + "static/media/reel.2b0d10d4.svg";